import React, { useEffect, useRef, useState } from 'react';
import { Box, Text, Flex, Heading, Button, useBreakpointValue, useColorMode, useColorModeValue, Grid, GridItem, Spinner } from '@chakra-ui/react';
import { Link, useNavigate } from 'react-router-dom';
import Boxx from '../../components/common/boxhome/boxx';
import Scroll from '../../components/common/imagescroll/scroll';
import Footer from '../../components/footer/footer';
import Card from '../../components/common/card/card';
import { Skeleton, SkeletonCircle, SkeletonText } from '@chakra-ui/react'
import { Image } from '@chakra-ui/react';
import Carousel from 'react-multi-carousel';


const Home: React.FC = () => {
  const navigate = useNavigate();

  // const { toggleColorMode } = useColorMode()

  const bg = useColorModeValue('white', '#1C1C1C')
  const color = useColorModeValue('#FFFFF', 'white')
  const { colorMode, toggleColorMode } = useColorMode();

  const containerRef = useRef<HTMLDivElement>(null);
  const isPaused = useRef(false);
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const scrollSpeed = 1;
    let animationFrameId: number;

    const scroll = () => {
      if (container && !isPaused.current) {
        container.scrollLeft += scrollSpeed;

        // Reset scroll position for infinite loop effect
        if (container.scrollLeft >= container.scrollWidth / 2) {
          container.scrollLeft = 0;
        }
      }
      animationFrameId = requestAnimationFrame(scroll);
    };

    animationFrameId = requestAnimationFrame(scroll);

    const handlePause = () => {
      isPaused.current = true;
    };
    const handleResume = () => {
      isPaused.current = false;
    };

    // Attach event listeners
    container.addEventListener("mouseenter", handlePause);
    container.addEventListener("mouseleave", handleResume);
    container.addEventListener("touchstart", handlePause);
    container.addEventListener("touchend", handleResume);

    return () => {
      cancelAnimationFrame(animationFrameId);
      // Cleanup event listeners
      container.removeEventListener("mouseenter", handlePause);
      container.removeEventListener("mouseleave", handleResume);
      container.removeEventListener("touchstart", handlePause);
      container.removeEventListener("touchend", handleResume);
    };
  }, []);
  const images = [
    '/assets/images/svg/brandingpage.jpg',
    '/assets/images/svg/awarenesspage.jpg',
    '/assets/images/svg/revenurpage.jpg',
    '/assets/images/svg/socialmeadipage.jpg',
    '/assets/images/svg/seo.jpg',
    '/assets/images/svg/performancepage.jpg',
  ];
  const names = [
    { name: 'Branding Solutions', path: '/digitalbranding' },
    { name: 'Awareness Campaigns', path: '/awarenesssoutions' },
    { name: 'Revenue Growth', path: '/revenuegrowth' },
    { name: 'Social Media Management', path: '/socialmedia' },
    { name: 'SEO Optimization', path: '/seo' },
    { name: 'Performance Analytics', path: '/performancemarketing' }
  ];
  const handleButtonClick = () => {
    navigate("/service");
  };
  const overlayColorLight = 'rgba(255, 255, 255, 0.7)';
  const overlayColorDark = 'rgba(0, 0, 0, 0.7)';
  const overlayColor = useColorModeValue(overlayColorLight, overlayColorDark);
  const [vedioSrc, setvedioSrc] = useState("/assets/video/herosectionanimation.mp4")
  const [vedioKey, setvedioKey] = useState(0)
  useEffect(() => {
    if (colorMode == "light") {
      setvedioSrc("/assets/video/herosectionwhite.mp4")
    } else {
      setvedioSrc("/assets/video/herosectionanimation.mp4")
    }
    setvedioKey((prvKey) => prvKey + 1)
  }, [colorMode])
  const darkpath = "/assets/video/herosectionanimation.mp4"
  const whitepath = "/assets/video/herosectionwhite.mp4"
  const isFullScreen = useBreakpointValue({ base: false, md: true });
  const [isVideoPlay, setisVideoPlay] = useState(false)

  const handleCanPlay = () => {
    setisVideoPlay(true)
  }

  useEffect(()=>{
    setisVideoPlay(false)
  },[colorMode])


  return (

    // import Ai7 from '../../lotti-file/digitalbranding/brandingwhite.json';

    //     <Lottie
    //     animationData={colorMode === 'light' ? service.animationDataLight : service.animationDataDark}
    //     loop={true}
    // />  <Lottie
    //                                     animationData={colorMode === 'light' ? service.animationDataLight : service.animationDataDark}
    //                                     loop={true}
    //                                 />
    <Box>
      
      <Flex
        bg={bg}
        direction="column"
        align="center"
        justify="center"
        height="auto"
        width="auto"
        padding="0"
      >

        {!isVideoPlay && <Box alignItems='center'><Spinner color='red.500' /></Box>}
        {isVideoPlay && <Box textAlign="center" mt={{ base: '5%', md: '5%' }} mb={{ base: '40px', md: '20px' }} >
          <Text
            fontFamily="'Gilroy-SemiBold', sans-serif"
            fontSize={{ base: '32px', md: '64px' }}
            fontWeight="400"
            lineHeight={{ base: '40px', md: '58px' }}
            letterSpacing="-0.25px"

          >

            <Text as="span" color={color}>Delivering </Text>
            <Text as="span" color="#FE3A3A" fontFamily="'Cags Hetonal', sans-serif">Different</Text>
          </Text>

          <Box
            width="auto"
            height="auto"
            mx="auto"
            mt="10px"
            border="1.7px solid"
            sx={{
              borderImageSource: colorMode === 'light'
                ? 'linear-gradient(270deg, #FFFFFF 0%, #C92E2E 50%, #FFFFFF 100%)'
                : 'linear-gradient(270deg, #1C1C1C 0%, #C92E2E 50%, #1C1C1C 100%)',
              borderImageSlice: 1,
            }}
            borderRadius="md"
          />
        </Box>}

        {isVideoPlay && <Box display={{ base: 'block', md: 'none' }} textAlign="center" mt="10px">
          <Text fontSize="12px" color={color} fontFamily="'Gilroy-Medium', sans-serif">
            A Digital Marketing Studio
          </Text>
        </Box>}

        <Box position="relative" textAlign="center" mt={{ base: '8%', md: '4%' }}       >
          <Box
            position="absolute"
            top={0}
            left={0}
            right={0}
            bottom={{ md: "-37%", base: "30%" }}
            overflow="hidden"
            zIndex={0}

          >
            <video key={vedioKey} autoPlay loop muted onCanPlay={handleCanPlay}
            >
              <source src={vedioSrc} type="video/mp4" />
            </video>
          </Box>

          {isVideoPlay && <Box position="relative" zIndex={1} textAlign="center" px={{ base: '20px', md: '0' }}>
            <Heading
              fontFamily="'Gilroy-SemiBold', sans-serif"
              fontSize={{ base: '24px', md: '48px', lg: '90px' }}
              fontWeight="400"
              lineHeight={{ base: '32px', md: '48px', lg: '122px' }}
              letterSpacing="-0.25px"
              color={color}
            >
              To help you craft your own unique <span style={{ color: '#FE3A3A', fontFamily: "'Cags Hetonal', sans-serif" }}>growth</span> journey.
            </Heading>

            {/* Button */}
            <Box mt={{ base: '20px', md: '50px' }} display={{ base: 'block', md: 'flex' }} justifyContent="center">
              <Button
                onClick={handleButtonClick}
                fontFamily="'Gilroy-SemiBold', sans-serif"
                colorScheme="red"
                color='white'
                backgroundColor="#FE3A3A"
                borderRadius="10px"
                px={{ base: '20px', md: '40px' }}
                py="20px"
              >
                Explore More
              </Button>
            </Box>

            {/* Gradient Background */}
            <Box
              position="absolute"
              bottom={{ base: "-100px", md: "-130px" }}
              left="0"
              right="0"
              color={color}
              height="10%"
              bgGradient={colorMode === "dark" ? "linear(to-t, #1C1C1C 0%, rgba(28, 28, 28, 0) 100%)" : "none"}
              zIndex={2}
            />
          </Box>}
        </Box>

        {
          isFullScreen && (
            <Box mt="270px" color={color}>
              <Text fontFamily="'Gilroy-Regular', sans-serif" fontSize="28px" color={color}>
                What we Offer
              </Text>
            </Box>
          )
        }

        {
          isFullScreen && (
            <Box textAlign="center" mt="50px">
              <Heading
                fontFamily="'Gilroy-SemiBold', sans-serif"
                fontSize="64px"
                fontWeight="400"
                lineHeight="78px"
                letterSpacing="-0.25px"
              >
                <Text as="span" fontFamily="'Gilroy-SemiBold', sans-serif" color={color}>
                  Our{' '}
                </Text>
                <Text as="span" fontFamily="'Cags Hetonal', sans-serif" color="#FE3A3A">
                  Top Services
                </Text>{' '}
                <Text as="span" fontFamily="'Gilroy-SemiBold', sans-serif" color={color}>
                  that help you
                </Text>
              </Heading>
              <Text
                fontFamily="'Gilroy-SemiBold', sans-serif"
                fontSize="64px"
                fontWeight="400"
                lineHeight="122px"
                letterSpacing="-0.25px"
                mt="10px"
                color={color}
              >
                <Text as="span" fontFamily="'Cags Hetonal', sans-serif" color="#FE3A3A">
                  Stand out
                </Text>{' '}
                <Text as="span" fontFamily="'Gilroy-SemiBold', sans-serif" color={color}>
                  from others
                </Text>
              </Text>
            </Box>
          )
        }

        {/* Mobile-specific content */}
        <Box mt="20px" textAlign="center">
          <Box display="flex" flexDirection="column" alignItems="center" position="relative">
            {/* Mobile Background Video */}
            {/* <video
            autoPlay
            loop
            muted
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              zIndex: -1, // Place behind the text
            }}
          >
            <source src="/assets/video/herosectionanimation.mp4" type='video/mp4' />
            Your browser does not support the video tag.
          </video> */}

            {/* <Text
            px={{ base: '10px' }}

            fontFamily="'Gilroy-Regular', sans-serif"
            fontSize="16px"
            fontWeight="400"
            lineHeight="24px"
            letterSpacing="0.5px"
            color={color}
            mt="20px"
            zIndex={1} // Ensure text is above the video
            position="relative"
            textAlign='justify'
          >
            From content to campaigns, we deliver results that reflect your brand’s distinct identity, helping you stand out and succeed in a crowded market.
          </Text> */}

            {/* Only one Explore Button for mobile */}
            {/* <Box mt="20px">
            <Button
              onClick={handleButtonClick}
              fontFamily="'Gilroy-SemiBold', sans-serif"
              // colorScheme="red"
              backgroundColor="#FE3A3A"
              borderRadius="5.22px"
              fontSize="16px"
              color={color}
            >
              Explore More
            </Button>
          </Box> */}
          </Box>
        </Box>

        <Box mt="38px" display={{ base: 'block', md: 'none' }} textAlign="center">
          <Text fontFamily="'Gilroy-Regular', sans-serif" fontSize="12px" color={color}>
            What we Offer
          </Text>
        </Box>

        <Box textAlign="center" mt="20px" display={{ base: 'block', md: 'none' }}>
          <Heading
            fontFamily="'Gilroy-SemiBold', sans-serif"
            fontSize="28px"
            fontWeight="400"
            lineHeight="38px"
            letterSpacing="-0.25px"
            color={color}
          >
            <Text as="span" >Our </Text>
            <Text as="span" color="#FE3A3A" fontFamily="'Cags Hetonal', sans-serif">Top Services</Text>
            <Text as="span" > that help you</Text>
          </Heading>

          <Text
            fontFamily="'Cags Hetonal', sans-serif"
            fontSize="28px"
            fontWeight="400"
            lineHeight="38px"
            letterSpacing="-0.25px"
            color={color}
            mt="10px"
          >
            <Text as="span" color="#FE3A3A">Stand out </Text>
            <Text as="span" color={color} fontFamily="'Gilroy-SemiBold', sans-serif" >from others</Text>
          </Text>
        </Box>

        {/* Card scroll design */}
        <Box
          mt="30px"
          mx="auto"
          height={{ md: "80vh", base: "29vh" }}
          width="90%"
          borderRadius="160% / 80%"
          overflow="hidden"
          textAlign="center"
        >
          <Box
            ref={containerRef}
            display="flex"
            width="fit-content"
            height="100%"
            className="scrolling-container"
            overflow="hidden"
            style={{ whiteSpace: "nowrap" }}
          >
            {[...images, ...images].map((src, index) => (
              <Box
                key={index}
                flexShrink={0}
                width="40%"
                height="100%"
                position="relative"
                pl="2%"
              >
                <Image
                  src={src}
                  alt={`Scrolling Image ${index + 1}`}
                  width="100%"
                  height="100%"
                  objectFit="cover"
                />
                <Link
                  to={names[index % names.length].path}
                  style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    color: '#fff',
                    fontWeight: 'bold',
                    fontFamily: "'Gilroy-Regular', sans-serif",
                    fontSize: window.innerWidth < 768 ? '6px' : '16px',
                    textAlign: 'center',
                    backgroundColor: 'rgba(0, 0, 0, 0.7)',
                    padding: window.innerWidth < 768 ? '8px 12px' : '10px 15px',
                    borderRadius: '12px',
                    textDecoration: 'none',
                    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.5)',
                    width: window.innerWidth < 768 ? '80%' : 'auto',
                    maxWidth: '300px',
                    transition: 'transform 0.2s, box-shadow 0.2s',
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.transform = 'translate(-50%, -50%) scale(1.05)')
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.transform = 'translate(-50%, -50%) scale(1)')
                  }
                >
                  {names[index % names.length].name}
                </Link>


              </Box>
            ))}
          </Box>
        </Box>
        <Box mt="30px" display={{ base: 'block', md: 'block', lg: 'block' }} textAlign="center">
          <Text fontFamily="'Gilroy-Regular', sans-serif" fontSize={{ base: '12px', md: '28px' }} color={color} fontWeight="400" lineHeight={{ base: '28px', md: '36px' }}>
            How we Toss
          </Text>
        </Box>
        <Box
          mt="3%"
          textAlign="center"
          width="auto"
          height="auto"
          position="relative"
          left="auto"
          gap="0px"
          opacity="1"
        >
          <Heading
            fontFamily="Gilroy-SemiBold"
            fontSize={{ base: '32px', md: '64px' }}
            fontWeight="400"
            lineHeight={{ base: '40px', md: '78px' }}
            letterSpacing="-0.25px"
            color={color}
          >
            With this <span style={{ color: '#FE3A3A', fontFamily: "'Cags Hetonal', sans-serif" }}>5 steps</span> we work for you to
          </Heading>
          <Heading
            fontFamily="'Gilroy-SemiBold', sans-serif"
            fontSize={{ base: '32px', md: '64px' }}
            fontWeight="400"
            lineHeight={{ base: '40px', md: '78px' }}
            letterSpacing="-0.25px"
            color={color}
          >
            <span style={{ color: '#FE3A3A', fontFamily: "'Cags Hetonal', sans-serif" }}>grow</span> your Business
          </Heading>
        </Box>
        <Card />
        <Box mt={{ base: '20px', md: '30px' }} display={{ base: 'block', md: 'block', lg: 'block' }} textAlign="center">
          <Text
            fontFamily="'Gilroy-Regular', sans-serif"
            fontSize={{ base: '16px', md: '28px' }}
            color="white"
            fontWeight="400"
            lineHeight={{ base: '24px', md: '36px' }}
          >
            Client Reflections
          </Text>
        </Box>

        <Box width='auto' height='auto' mt='20px' >
          <Text
            px={{ md: "10px", base: "10px" }}
            fontSize={{ base: '32px', md: '64px' }}
            fontWeight='400'
            textAlign={{ base: 'center', md: 'center' }}
            color={color}
            fontFamily="'Gilroy-Regular', sans-serif"
          >
            Our <Text as="span" color="#FE3A3A" fontFamily="'Cags Hetonal', sans-serif">clients</Text> describe their
            <Text as="span" color="#FE3A3A" fontFamily="'Cags Hetonal', sans-serif"> "RareToss"</Text> effects!
          </Text>
        </Box>


        <Scroll />

        <Box mt={{ base: '50px', md: '160px' }} display={{ base: 'block', md: 'block', lg: 'block' }} textAlign="center">
          <Text
            fontFamily="'Gilroy-Regular', sans-serif"
            fontSize={{ base: '16px', md: '28px' }}
            color={color}
            fontWeight="400"
            lineHeight={{ base: '24px', md: '36px' }}
          >
            Get in touch
          </Text>
        </Box>

        <Boxx />

        <Footer />
      </Flex >
    </Box>

  );
};

export default Home;